
export const getCityFromAddress = (address) => {
    const stateCode = address.state;
    const city = address.city;

	return `${city} (${stateCode})`;
}